import { ApolloProvider } from '@apollo/client/react';
import { useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Outlet, useParams } from 'react-router';

import ErrorBoundary from 'components/core/errors/ErrorBoundary';
import LoggingService from 'components/core/logging/LoggingService';
import EnvironmentModeWarning from 'components/ui/shared/EnvironmentModeWarning';
import LoggedInAsBanner from 'components/ui/shared/LoggedInAsBanner';
import { usePathPattern } from 'hooks/usePathPattern';
import EDealerProvider from 'providers/EDealerProvider';
import NavigationPendingReporter from 'providers/NavigationPendingReporter';

import { client } from 'store/apollo/ApolloClient';

import GlobalStyles from 'styles/globalStyles';

import RouterRoot from './RouterRoot';

const CoreRoute = () => {
  const pathPattern = usePathPattern();
  const parameters = useParams();

  /**
   * Adding params as path dependency so that we log the path pattern (e.g. /retail/:id)
   * whenever the parameter gets update, which signifies a route change
   */
  useEffect(() => {
    LoggingService.trackPageView(pathPattern);
    /*
     * `parameters` is an intentional re-run trigger, see comment above
     */
    // oxlint-disable-next-line react/exhaustive-effect-dependencies
  }, [parameters, pathPattern]);

  return (
    <>
      <GlobalStyles />
      <ErrorBoundary>
        <ApolloProvider client={client}>
          <EDealerProvider>
            <NavigationPendingReporter />
            <DndProvider backend={HTML5Backend}>
              <LoggedInAsBanner />
              <RouterRoot>
                <Outlet />
              </RouterRoot>
              <EnvironmentModeWarning />
            </DndProvider>
          </EDealerProvider>
        </ApolloProvider>
      </ErrorBoundary>
    </>
  );
};

export default CoreRoute;
